import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  pageContainer: {
    padding: "0px 30px",
  },
  pageTitleContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: `${theme.shape.padding}px 0`,
  },
  pageTitle: {
    fontSize: 40,
    marginBottom: theme.shape.padding,
    fontWeight: "bold",
  },
  stepsContainer: {
    width: "100%",
    marginBottom: theme.shape.padding,
  },
  image: {
    width: 120,
  },
  connectButton: {
    padding: theme.shape.padding,
    marginBottom: 10,
  },
  onboardingStep: {
    width: "33%",
    height: 320,
    padding: "15px 30px",
    position: "relative",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    justifyContent: "space-between",
    borderRadius: theme.shape.borderRadius,
    border: `2px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
  },
  connectStepContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
  },
  stepNumberContainer: {
    position: "relative",
  },
  completed: {
    top: 10,
    right: -5,
    zIndex: 999,
    fontSize: 25,
    position: "absolute",
    color: theme.palette.success.main,
    backgroundColor: theme.palette.background.paper,
  },
  loading: {
    top: 10,
    right: -5,
    zIndex: 999,
    borderRadius: 15,
    position: "absolute",
    backgroundColor: theme.palette.background.paper,
  },
  stepNumber: {
    width: 70,
    height: 70,
    padding: 0,
    display: "flex",
    borderRadius: 35,
    fontWeight: "bold",
    alignItems: "center",
    justifyContent: "center",
    border: `3px solid ${theme.palette.divider}`,
    "& p": {
      padding: 10,
      fontSize: 35,
      marginBottom: 0,
    },
  },
  titleContentContainer: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    justifyContent: "center",
  },
  stepTitle: {
    fontWeight: "bold",
  },
  subsequentStepText: {
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    paddingTop: theme.shape.padding,
  },
  span: {
    fontSize: 15,
    marginTop: theme.shape.padding,
    color: theme.palette.text.secondary,
  },
  microsoftBlumiraImgContainer: {
    padding: "15px 0",
    wiidth: "100%",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
  },
  microsoftBlumiraImg: {
    width: "80%",
  },
  learnMoreVideoContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
  },
  sectionTitle: {
    fontSize: 18,
    fontWeight: "bold",
  },
  learnMoreSectionContainer: {
    padding: 30,
    flexDirection: "column",
  },
  learnMoreLinkContainer: {
    display: "flex",
    flexDirection: "column",
    "& a": {
      paddingBottom: theme.shape.padding,
      color: theme.palette.primary.main,
    },
  },
  linkContainer: {
    display: "flex",
    "& p": {
      marginLeft: theme.shape.padding * 2,
    },
  },
  linkButton: {
    padding: 10,
    cursor: "pointer",
    color: theme.palette.common.white,
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.primary.main,
  },
  link: {
    cursor: "pointer",
    color: theme.palette.primary.main,
    "&:hover": {
      color: theme.palette.primary.main,
      textDecoration: "underline",
    },
  },
  videoSectionContainer: {
    padding: 30,
    marginLeft: theme.shape.padding,
  },
  disclaimerText: {
    fontSize: 10,
    paddingTop: theme.shape.padding,
  },
  dialogHeaderContainer: {
    display: "flex",
    paddingRight: 30,
    alignItems: "center",
    justifyContent: "space-between",
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  dialogContent: {
    padding: 30,
  },
  headerCtaContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-around",
    "& p": {
      marginBottom: 0,
      paddingRight: theme.shape.padding,
    },
    "& a": {
      paddingRight: theme.shape.padding,
    },
  },
  ruleContainer: {
    display: "flex",
    flexDirection: "column",
  },
  dialogFooter: {
    padding: 30,
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    justifyContent: "center",
    borderTop: `1px solid ${theme.palette.divider}`,
  },
  close: {
    cursor: "pointer",
  },
  list: {
    paddingLeft: 20,
    marginBottom: 0,
  },
  listItem: {
    paddingBottom: theme.shape.padding,
  },
  textFieldContainer: {
    display: "flex",
    flexDirection: "column",
  },
  textField: {
    width: "100%",
    marginBottom: theme.shape.padding,
  },
  successContainer: {
    width: 500,
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    justifyContent: "center",
    "& p": {
      marginBottom: theme.shape.padding,
    },
  },
  checkCircle: {
    fontSize: 50,
    marginBottom: theme.shape.padding,
    color: theme.palette.success.main,
  },
  connectionDialogContainer: {
    minHeight: 500,
  },
  buttonContainer: {
    zIndex: 999,
    display: "flex",
    justifyContent: "flex-end",
    paddingBottom: theme.shape.padding * 2,
  },
  button: {
    marginLeft: theme.shape.padding,
  },
  absoluteDotProgressContainer: {
    bottom: 30,
    width: "100%",
    display: "flex",
    position: "absolute",
    alignItems: "center",
    justifyContent: "center",
  },
  flexDotProgressContainer: {
    width: "100%",
    marginTop: -85, // align with buttons
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    paddingBottom: theme.shape.padding * 2,
  },
  alert: {
    marginTop: -theme.shape.padding,
    marginBottom: theme.shape.padding,
  },
  dialogSectionContainer: {
    display: "flex",
    flexDirection: "column",
    paddingBottom: theme.shape.padding,
  },
}));
